import { ApiClient } from "../ApiClient";

const INCOME_SUMMARY_ENDPOINT = "finances/income-summary";
const INCOME_REVIEW_ENDPOINT = "finances/income/review";

/**
 * Fetch income dashboard data (total summary, history chart, candidates, confirmed transactions).
 */
export const getIncomeSummary = async (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  const url = queryString
    ? `${INCOME_SUMMARY_ENDPOINT}?${queryString}`
    : INCOME_SUMMARY_ENDPOINT;

  const res = await ApiClient.get(url);
  return await res.json();
};

/**
 * Update a single transaction's income_confirmed status ('IN' or 'NI').
 */
export const updateIncomeDecision = async (transactionUuid, decision) => {
  const res = await ApiClient.put(`finances/transactions/${transactionUuid}/`, {
    income_confirmed: decision,
  });
  return await res.json();
};

/**
 * Submits user decisions (Income/Not Income) for a batch of transactions.
 */
export const bulkUpdateIncomeConfirmation = async (payload) => {
  const res = await ApiClient.post(INCOME_REVIEW_ENDPOINT, payload);
  return await res.json();
};
